














































































// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { mapGetters } from 'vuex';

// Third party
import dayjs, { UnitType } from 'dayjs';

// Constants
import Assets from '@/constants/assets';
import Constants from '@/constants/constants';

// Components
import Btn, {
    BtnWidth,
    BtnColor,
} from '@/shared/components/btn.component.vue';
import Input, {
    InputType,
    InputStyle,
} from '@/shared/components/input.component.vue';
import SpotlightText, {
    SpotlightTextColor,
    SpotlightTextBorderType,
} from '@/shared/components/SpotlightText.component.vue';
import Checkbox from '@/shared/components/checkbox.component.vue';

// Services
import { ConvocationService } from '@/manager/convocation/convocation.service.ts';
import UtilsService from '@/core/services/utils.service';

// Filters
import formatDate from '@/shared/filters/formatDate.filter.ts';

@Component({
    components: {
        Btn,
        Input,
        SpotlightText,
        Checkbox,
    },
    computed: {
        ...mapGetters({
            getConvocation: 'getConvocation',
        }),
    },
    filters: {
        formatDate,
    },
})
export default class ParticipantInscription extends Vue {
    @Prop() private id!: string;

    private inscriptionSuccess: boolean = true;
    private errorView: boolean = false;
    private assets = Assets;
    private data: any = { first_name: '', email: '', phone: '' };
    private privacyPolicy: boolean = false;
    private inputType = InputType;
    private inputStyle = InputStyle;
    private btnColor = BtnColor;
    private btnWidth = BtnWidth;
    private spotlightTextColor = SpotlightTextColor;
    private spotlightTextBorderType = SpotlightTextBorderType;
    private showingAlert = false;
    private errorText = 'Rellene todos los campos correctamente';
    private isValid: boolean = true;
    private getConvocation!: any;
    private error = { title: '', text: '' };


    private created() {
        this.fetchConvocation();
    }

    @Watch('data.phone')
    private watchPhone(newVal: any, oldVal: any) {
        if (!newVal) {
            this.data.phone = '+';
        } else if (newVal.charAt(0) != '+') {
            newVal = '+' + newVal;
            this.data.phone = newVal;
        } else {
            this.data.phone = newVal;
        }
    }


    get convocation() {
        return this.getConvocation(this.id);
    }

    get alertColor() {
        let color = this.spotlightTextColor.Primary;
        if (this.errorText !== '') {
            color = this.spotlightTextColor.Error;
        }
        return color;
    }

    get alertText() {
        let text = 'Inscripción realizada';
        if (this.errorText !== '') {
            text = this.errorText;
        }
        return text;
    }

    get hasError() {
        if (this.errorText === '') {
            return false;
        }
        return true;
    }

    get convocationLocation() {
        let location = '';
        if (this.convocation) {
            location = this.convocation.location.name;
        }
        return location;
    }

    get convocationDate() {
        let date = '';
        if (this.convocation) {
            date = this.convocation.timetables[0].date;
        }
        return date;
    }

    get convocationStartHour() {
        let startHour = '';
        if (this.convocation) {
            const splittedHour = this.convocation.timetables[0].timeStart.split(':');
            startHour = `${splittedHour[0]}:${splittedHour[1]}h`;
        }
        return startHour;
    }

    get showInscriptionForm() {
        return !this.inscriptionSuccess && !this.errorView;
    }

    get showSuccessMessage() {
        return this.inscriptionSuccess && !this.errorView;
    }

    get showErrorMessage() {
        return this.errorView;
    }


    private validateForm() {
        this.errorText = '';
        this.isValid = true;
        if (!this.privacyPolicy) {
            this.errorText = 'Debe aceptar la política de privacidad';
            this.isValid = false;
        } else if (!UtilsService.checkValidEmail(this.data.email)) {
            this.errorText = 'E-mail incorrecto';
            this.isValid = false;
        }
        this.showAlert();
    }

    private showAlert() {
        this.showingAlert = true;
        setTimeout(() => {
            this.showingAlert = false;
        }, Constants.notificationMessageTimeToAppear);
    }

    private inscription() {
        this.validateForm();
        if (this.data.phone) {
            this.data.phone = this.data.phone.replaceAll(/\s/g, '');
        }
        if (this.isValid) {
            ConvocationService.participantInscription(
                this.id,
                this.data,
            )
                .then(this.onSuccess, this.onError)
                .catch(this.onError);
        }
    }

    private onSuccess() {
        this.inscriptionSuccess = true;
        window.location.href = Constants.inscriptionCompleteUrl;
        window.open(Constants.inscriptionCompleteUrl, '_blank');
    }

    private onError(err: any) {
        if (err.response && err.response.status === 406) {
            this.errorText = err.response.data.detail;
        } else {
            this.errorText = 'Debe rellenar todos los campos';
        }
        this.showAlert();
    }

    private setNotFoundError(err: any) {
        if (err.response && err.response.status === 404) {
            this.errorView = true;
            this.error = {
                title: 'Ups, parece que estamos teniendo algún problema...',
                text: ` Inténtalo de nuevo más tarde o entra en&nbsp;
                            <a class="hyperlink" target="_blank" href="https://www.levelupdesarrollo.com/calendarios/">nuestra web</a>,
                            para buscar la convocatoria más cercana`,
            };
        }
    }

    private isPastDate(date: string) {
        let val = false;
        const now = dayjs();
        if (date) {
            const dayjsDate = dayjs(date, { locale: 'es' });
            const dateDiff = now.diff(dayjsDate, ('hours' as UnitType));
            if (dateDiff > 0) {
                val = true;
            }
        }
        return val;
    }

    private setPastConvocationError(data: any) {
        if (this.isPastDate(data.timetables[0].date)) {
            this.errorView = true;
            this.error = {
                title: 'Ups, llegas tarde...',
                text: ` Puedes entrar en <a class="hyperlink" target="_blank" href="https://www.levelupdesarrollo.com/calendarios/">nuestra web</a>&nbsp;
                            para buscar la convocatoria más cercana`,
            };
        }
    }

    private fetchConvocation() {
        this.$store.dispatch('fetchConvocationPublic', { id: this.id })
            .then(
                (res) => {
                    this.setPastConvocationError(res);
                },
                (err) => {
                    this.setNotFoundError(err);
                },
            );
    }
}
